import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@maersk-global/mds-react-wrapper/styles/core.css';
import './index.scss';
import App from './App';
import { PublicClientApplication,EventType } from '@azure/msal-browser';
import { msalConfig } from './auth/auth-config';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter} from "react-router-dom";

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event: any) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    console.log('Login successful. Account:', event.payload.account);
    msalInstance.setActiveAccount(event.payload.account);
  }
});

window.addEventListener("DOMContentLoaded", function (e) {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <BrowserRouter>
      <App msalInstance={msalInstance} />
    </BrowserRouter>
  );
});

